<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <div
      v-if="patient"
      class="structure"
      :class="{ 'section-highlight': patientHasData }"
    >
      <span class="structure__heading"><i
        class="far fa-user mr-2"
        aria-hidden="true"
      />{{ $t('global.personalData') }}</span>
      <b-row class="mt-1">
        <b-col
          :class="{ 'highlight': hasPatientNameDiff }"
          lg="4"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'required': showErrors && !name }"
          >
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.patName, hasPatientNameDiff)"
              v-model="name.selected"
              :unchecked-value="null"
            />
            <small>{{ $tc('global.name',1) }}</small>
          </div>
          <h4
            :class="{ 'item-selected': name.selected && integrationPatient && hasPatientNameDiff }"
            class="collapsable-card-title inside"
          >
            {{ patient.patName ? patient.patName : '-' }}
          </h4>
        </b-col>
        <b-col
          v-if="patient.patMiddleName"
          :class="{ 'highlight': hasPatientMiddleNameDiff }"
          lg="4"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.patMiddleName, hasPatientMiddleNameDiff)"
              v-model="middleName.selected"
              :unchecked-value="null"
            />
            <small>{{ $t('global.middleName') }}</small>
          </div>
          <h4
            :class="{ 'item-selected': middleName.selected && integrationPatient && hasPatientMiddleNameDiff }"
            class="collapsable-card-title inside"
          >
            {{ patient.patMiddleName ? patient.patMiddleName : '-' }}
          </h4>
        </b-col>
        <b-col
          :class="{ 'highlight': hasPatientSurname1Diff }"
          lg="4"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'required': showErrors && !surname1 }"
          >
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.patSurname1, hasPatientSurname1Diff)"
              v-model="surname1.selected"
              :unchecked-value="null"
            />
            <small>{{ $t('global.surname1') }}</small>
          </div>
          <h4
            :class="{ 'item-selected': surname1.selected && integrationPatient && hasPatientSurname1Diff }"
            class="collapsable-card-title inside"
          >
            {{ patient.patSurname1 ? patient.patSurname1 : '-' }}
          </h4>
        </b-col>
        <b-col
          :class="{ 'highlight': hasPatientSurname2Diff }"
          lg="4"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.patSurname2, hasPatientSurname2Diff)"
              v-model="surname2.selected"
              :unchecked-value="null"
            />
            <small>{{ $t('global.surname2') }}</small>
          </div>
          <h4
            :class="{ 'item-selected': surname2.selected && integrationPatient && hasPatientSurname2Diff }"
            class="collapsable-card-title inside"
          >
            {{ patient.patSurname2 ? patient.patSurname2 : '-' }}
          </h4>
        </b-col>
        <b-col
          :class="{ 'highlight': hasPatientBirthdateDiff }"
          lg="4"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.patBirthdate, hasPatientBirthdateDiff)"
              v-model="birthdate.selected"
              :unchecked-value="null"
            />
            <small>{{ $t('global.birthday') }}</small>
          </div>
          <h4
            :class="{ 'item-selected': birthdate.selected && integrationPatient && hasPatientBirthdateDiff }"
            class="collapsable-card-title inside"
          >
            {{ patient.patBirthdate | date }}
          </h4>
        </b-col>
        <b-col
          :class="{ 'highlight': hasPatientGenderDiff }"
          lg="4"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'required': showErrors && !gender }"
          >
            <b-form-checkbox
              v-if="showPatientPersonalDataCheckbox(patient.gender, hasPatientGenderDiff)"
              v-model="gender.selected"
              :unchecked-value="null"
            />
            <small>{{ $t('entities.patient.gender') }}</small>
          </div>
          <h4
            :class="{ 'item-selected': gender.selected && integrationPatient && hasPatientGenderDiff }"
            class="collapsable-card-title inside"
          >
            {{ patient.gender ? patient.gender.name : '-' }}
          </h4>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
export default {
    name: 'PatientPersonalDataCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array },
        patientDataDiff: { type: Object },
        showErrors: { type: Boolean, default: false },
        integrationPatient: { type: Boolean },
        localPatient: { type: Boolean },
        continueWithCaseCreation: { type: Boolean, default: false }
    },
    data() {
        return {
            birthdate: {},
            name: {},
            middleName: {},
            surname1: {},
            surname2: {},
            gender: {}
        }
    },
    computed: {
        hasPatientNameDiff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.patName)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.patName !== this.patientDataDiff.patName : true
            }
            return hasDiff
        },
        hasPatientMiddleNameDiff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.patMiddleName)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.patMiddleName !== this.patientDataDiff.patMiddleName : true
            }
            return hasDiff
        },
        hasPatientSurname1Diff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.patSurname1)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.patSurname1 !== this.patientDataDiff.patSurname1 : true
            }
            return hasDiff
        },
        hasPatientSurname2Diff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.patSurname2)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.patSurname2 !== this.patientDataDiff.patSurname2 : true
            }
            return hasDiff
        },
        hasPatientBirthdateDiff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.patBirthdate)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.patBirthdate !== this.patientDataDiff.patBirthdate : true
            }
            return hasDiff
        },
        hasPatientGenderDiff() {
            let hasDiff = null
            if (this.$_isEmpty(this.patientDataDiff.gender)) {
                hasDiff = false
            } else {
                hasDiff = this.localPatient
                    ? this.patient.gender?.code !== this.patientDataDiff.gender?.code : true
            }
            return hasDiff
        },
        patientHasData() {
            return this.hasPatientBirthdateDiff ||
                this.hasPatientGenderDiff ||
                this.hasPatientMiddleNameDiff ||
                this.hasPatientNameDiff ||
                this.hasPatientSurname1Diff ||
                this.hasPatientSurname2Diff
        }
    },
    mounted() {
        this.initializePatientPersonalDataFields()
    },
    methods: {
        initializePatientPersonalDataFields() {
            this.birthdate = {
                selected: this.hasPatientBirthdateDiff,
                value: this.patient.patBirthdate
            }
            this.name = {
                selected: this.hasPatientNameDiff,
                value: this.patient.patName
            }
            this.middleName = {
                selected: this.hasPatientMiddleNameDiff,
                value: this.patient.patMiddleName
            }
            this.surname1 = {
                selected: this.hasPatientSurname1Diff,
                value: this.patient.patSurname1
            }
            this.surname2 = {
                selected: this.hasPatientSurname2Diff,
                value: this.patient.patSurname2
            }
            this.gender = {
                selected: this.hasPatientGenderDiff,
                value: this.patient.gender
            }
        },
        showPatientPersonalDataCheckbox(data, dataHasDiff) {
            if (this.continueWithCaseCreation) {
                return this.integrationPatient && data && dataHasDiff
            } else {
                return this.integrationPatient && data
            }
        }
    }
}
</script>

<style scoped>
    .required{
        color: red;
    }
</style>
